import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, c1, rx, sImaginary) {
  var result = Complex.createComplex(1, 2 * sImaginary * rx * c1).divide(complexDenominator);
  return result;
}

export function computeComplexFF() {
  return Complex.createComplex(0, 0);
}
